<template>
  <div class="form__group  form__group--move dropdown"
    :class="getInstanceClass()"
    ref="multiselect">
    <span class="hitzone" @click="isOpen=!isOpen"></span>
    <div class="form__input"  :class="isFocused()">
      <input
        :id="`${id}_input`"
        :value="isOpen ? '' : (selectedItem?.label || '')"
        :placeholder="isOpen ? '' : label"
        @focus="isOpen=true"
        @blur="onBlur()"
        type="text"
        readonly />
    </div>
    <div class="dropdown__content" v-if="isOpen" :class="showComponent()">
      <ul class="dropdown__list">
        <li class="dropdown__item"
          v-for="(item, index) in gender" :key="item.Code"
          :class="{ selected : isSelected(item) }"
          @click="setSelectedItem(item)">
          <slot name="item" :item="item">{{ item.label }}</slot>
      </li>
      </ul>
      <div class="dropdown__listheader"
        v-if="closeDropdownButtonText !== '' && listType !== 'genders'">
        <button
          class="button button--sec"
          @click="isOpen=false">{{closeDropdownButtonText}}</button>
      </div>
    </div>
    <label :for="id">{{ label }}</label>
    <LennocIcon image="chevron-bottom"></LennocIcon>
  </div>
</template>

<script lang="ts" setup>
  import { onMounted, onUnmounted, PropType, ref, watch, nextTick  } from 'vue'
  import { SelectItem } from '../../types/types'

  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    domclass: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true,
      default() {
        return ''
      }
    },
    value: {
      type: Object,
      default: null
    },
    gender: {
      type: Array as PropType<Array<SelectItem>>,
      default: []
    },
    placeholder: {
      type: String,
      default () {
        return ''
      }
    },
    modelValue: {
      type: String,
        default: null
    },
    listType: {
      type: String,
      default: ''
    },
    closeDropdownButtonText: {
      type: String,
      default () {
        return 'Close'
      }
    },
    staticLabel: {
      type: Boolean,
      default: false
    },
    closeDropdownOnCheckboxClick: {
      type: Boolean,
      default () {
        return false
      }
    }
  })

  const emits = defineEmits([
    'update:modelValue',
    'blur',
    'focus',
    'setHeight'
  ])
  const multiselect = ref()
  const isOpen = ref(false)
  const selectedItem = ref<SelectItem | null>(null)
  const checkgender = ref<Array<SelectItem>>([])


watch(() => props.modelValue, (newValue) => {
  if (newValue === "none") {
    selectedItem.value = props.gender.find(item => item.Code === "") || null
  } else if (!newValue) {
    selectedItem.value = null
  } else {
    selectedItem.value = props.gender.find(item => item.Code === newValue) || null
  }
}, { immediate: true })

  onMounted(() => {
    document.body.addEventListener('click', handleClickOutside)
    props.gender.forEach((el : SelectItem) => {
      addItem(el)
    })
  })


  const addItem = (item : SelectItem ) => {
    checkgender.value.push({
      Code: item.Code,
      label: item.label
    })
  }

  onUnmounted(() => {
    document.body.removeEventListener('click', handleClickOutside)
  })

  const getInstanceClass = () => {
    return [
      props.domclass,
      selectedItem.value ? 'form__group--touched ' : ''
    ].join(' ')
  }
  
  const handleClickOutside = (event: Event) => {
    if (!multiselect.value.contains(event.target)) {
      isOpen.value = false
    }
  }

  const onBlur = () => {
    emits('blur')
  }

  const isFocused = () => {
    return isOpen.value ? 'form__input--focus' : ''
  }

  const showComponent = () => {
    return isOpen.value ? 'dropdown__content--visible' : ''
  }

  const isSelected = (item: SelectItem) => {
    return selectedItem.value?.Code === item.Code
}

const setSelectedItem = (item: SelectItem) => {
  selectedItem.value = item
  isOpen.value = false

  const selectedCode = item.Code === "" ? "none" : item.Code
  emits("update:modelValue", selectedCode, props.id)
}

</script>
